import React from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import { PickersDay } from '@mui/x-date-pickers/PickersDay'
import clsx from 'clsx'
import { getDayEventDotColors } from './calendar-utils'
import useCalendarStyles from './calendar-styles'

const CalendarAgendaDay = props => {
  const {
    bookingsByDate,
    day,
    outsideCurrentMonth,
    className,
    ...other
  } = props
  const classes = useCalendarStyles()
  const dotColors = getDayEventDotColors(bookingsByDate, day)

  return (
    <Box className={classes.agendaDayRoot}>
      <PickersDay
        {...other}
        day={day}
        outsideCurrentMonth={outsideCurrentMonth}
        className={clsx(classes.agendaPickersDay, className)}
      />
      {!outsideCurrentMonth && dotColors.length > 0 && (
        <Box className={classes.agendaDayDots} aria-hidden="true">
          {dotColors.map((color, index) => (
            <span
              key={`${color}-${index}`}
              className={classes.agendaDayDot}
              style={{ backgroundColor: color }}
            />
          ))}
        </Box>
      )}
    </Box>
  )
}

CalendarAgendaDay.propTypes = {
  bookingsByDate: PropTypes.object.isRequired,
  day: PropTypes.object.isRequired,
  outsideCurrentMonth: PropTypes.bool,
  className: PropTypes.string,
}

CalendarAgendaDay.defaultProps = {
  outsideCurrentMonth: false,
  className: undefined,
}

export default CalendarAgendaDay
